<template>
<div>

    <div class="score">

        <div class="wrapper">

            <div class="score__title">
                {{ post_title }}
            </div>

            <div class="player-filter">

                <div class="player-filter__switch">
                    <ul>
                        <li>
                            <a @click.prevent="assoc = 'atp' "
                               :class="{ active: assoc == 'atp' }"
                               href="#">
                                <span>atp</span>
                            </a>
                        </li>
                        <li>
                            <a @click.prevent="assoc = 'wta'"
                               :class="{ active: assoc == 'wta' }"
                               href="#">
                                <span>wta</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="player-filter__type">
                    <select v-model="selectedEvent"
                            id="s2eventSelector"
                            name="s2eventSelector">
                        <!-- <option :value="event" v-for="event in events">{{event}}</option> -->
                    </select>
                </div>

            </div>

        </div>
    </div>

    <div class="wrapper wrapper--scoring wrapper--scoring__draws">
        <div class="player-filter__type">
            <select v-model="selectedRound"
                    id="s2roundSelector"
                    name="s2roundSelector">
                <!-- <option :value="round" v-for="round in possibleRounds">{{round}}</option> -->
            </select>
        </div>

        <div class="Draw-rounds" v-if="feed.length > 0">
            <ul>
                <li v-for="round in rounds">
                    <a href="#" :class="{ selected: selectedRound == round.id }"
                       @click.prevent="selectedRound = round.id">
                        <span>{{ getRoundLabel(round.id) }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="Draw-group" v-if="feed.length > 0">

            <div class="Draw-round" v-for="(round, roundIndex) in selectedRounds"
                :class="{ 'Draw-round--drawline' : drawline}">

                <div v-for="(match, matchIndex) in round.matches">

                    <score-card v-if="showMatch(match)"
                                :match="match"
                                mode="draws"
                                :detail="detail"
                                :flagPath="flagPath"
                                :key="match.id">
                    </score-card>
                    <score-line :flagPath="flagPath"
                                :match="lines[matchIndex]"
                                :key="match.id"
                                v-if="showLine(roundIndex, match)">
                    </score-line>
                    <score-empty :rounds="rounds"
                                 :round="round.id"
                                 :lines="lines"
                                 :pos="matchIndex"
                                 :flagPath="flagPath"
                                 :roundPos="roundIndex"
                                 :drawline="drawline"
                                 :key="match.id"
                                 :selectedRound="selectedRound"
                                 v-if="!showMatch(match) && ! showLine(roundIndex, match)">
                    </score-empty>

                </div>

            </div>

        </div>

        <div class="na" v-else>
            <div class="na__info" v-html="ico_info"></div>

            <div class="na__title" style="margin-bottom: 0">
                Draws not available
            </div>
        </div>
    </div>

</div>
</template>

<script>
    import axios      from 'axios'
    import DrawsCard  from './DrawsCard'
    import DrawsLine  from './DrawsLine'
    import MatchEmpty from './MatchEmpty'

    export default {
        props: [ 'preassoc', 'flag', 'detail', 'tournament', 'post_title' ],
        components: {
            'score-card': DrawsCard,
            'score-line': DrawsLine,
            'score-empty': MatchEmpty
        },
        data() {
            return {
                draws           : [],
                feed            : [],
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                events          : [],
                selectedEvent   : '',
                selectedRound   : '',
                selectedRounds  : [],
                lines           : [],
                rounds          : [],
                drawline        : false,
                assoc           : this.preassoc,
                tournament_slug : this.tournament,
                ico_info        : window.ico_info,
            }
        },
        watch: {
            assoc() {
                this.getFeed()
            },
            selectedEvent() {
                this.setupLines()
                this.setupDraws()
            },
            selectedRound(newValue, oldValue) {

                this.reloadRounds(newValue)
            }
        },
        created() {
            this.getFeed()
        },
        mounted() {
            let vm = this
            jQuery('#s2eventSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedEvent = this.value
            })

            jQuery('#s2roundSelector').select2({
                width: '100%'
            }).on('change', function () {
                vm.selectedRound = this.value
            })
        },
        methods: {
            showLine(roundIndex, match) {
                return roundIndex == 0 && !this.showMatch(match) && this.drawline
            },
            getFeed() {
                axios.get(`${window.feed_ip}/get/${this.assoc}/${this.tournament_slug}/draws`).then(response => {
                    this.feed = response.data
                    let feed = response.data

                    this.setupEvents(feed)
                    this.setupLines()
                    this.setupDraws()
                }).catch(function (error) {
                    console.log(error)
                })

            },
            setupEvents(feed) {
                let events = []

                for (let event of feed) {
                    events.push(event.description)
                }

                this.events = events
                this.selectedEvent = events[0]

                if (this.assoc == 'wta') {
                    if(this.feed[1] && this.feed[1].code == "LS"){
                        const temp = events[0];
                        events[0] = events[1];
                        events[1] = temp;
                    }
                    this.selectedEvent = events[0]

                }

                if((typeof window.atp_results_default !== 'undefined') && window.atp_results_default !== "default" && this.assoc == 'atp'){
                    this.selectedEvent = events[Number(window.atp_results_default)]
                }

                if((typeof window.wta_results_default !== 'undefined') && window.wta_results_default !== "default" && this.assoc == 'wta'){
                    this.selectedEvent = events[Number(window.wta_results_default)]
                }

                let vm = this

                jQuery('#s2eventSelector').empty().select2({
                    width: '100%',
                    data: events.map(function (event) {
                        return {
                            id: event,
                            text: event
                        }
                    })
                }).val(this.selectedEvent).trigger('change')
            },
            setupLines() {
                let currentEvent = this.getSelectedEvent()

                if (currentEvent.length > 0) {
                    this.lines = currentEvent[0].line
                }

            },
            setupDraws() {
                let currentEvent = this.getSelectedEvent()

                if (currentEvent.length > 0) {

                    this.rounds = currentEvent[0].rounds
                    this.selectedRound = currentEvent[0].rounds[0].id

                    let app = this

                    jQuery('#s2roundSelector').empty().select2({
                        width: '100%',
                        data: currentEvent[0].rounds.map(function (round) {
                            return {
                                id: round.id,
                                text: app.getRoundLabel( round.id ),
                            }
                        })
                    })

                    this.reloadRounds(currentEvent[0].rounds[0].id)

                }

            },
            getRoundLabel(round) {
                if (round == '1')
                    return 'Round 1'
                else if (round == '2')
                    return 'Round 2'

                if (this.type == 'wta') {
                    if (round == 'Q')
                        return 'Quarterfinals'
                    else if (round == 'S')
                        return 'Semifinals'
                    else if (round == 'F')
                        return 'Final'
                } else {
                    if (round == '5')
                        return 'Quarterfinals'
                    else if (round == '6')
                        return 'Semifinals'
                    else if (round == '7')
                        return 'Final'
                }

                if ( round == 'Q1' || round == 'R1' )
                    return 'Round 1'
                else if ( round == 'Q2' || round == 'R2' || round == "Q4" )
                    return 'Round 2'

                return round;
            },
            reloadRounds(selRound) {
                let eventRounds = this.rounds

                let selectedRoundIndex = eventRounds.findIndex(round => round.id == selRound)
                let selectedRounds = []

                if (selectedRoundIndex == 0) {
                    this.drawline = true
                } else {
                    this.drawline = false
                }

                if (selectedRoundIndex == eventRounds.length - 1) {

                    selectedRounds.push(eventRounds[selectedRoundIndex])

                } else {

                    selectedRounds.push(eventRounds[selectedRoundIndex])
                    selectedRounds.push(eventRounds[selectedRoundIndex + 1])

                }

                jQuery('#s2roundSelector').val(selRound).trigger('change')

                this.selectedRounds = selectedRounds
            },
            getSelectedEvent() {
                return this.feed.filter(event => event.description == this.selectedEvent)
            },
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail == undefined) {
                    return false
                }

                if (match.detail == '') {
                    return false
                }

                if (match.detail.state == 'F' || ( match.detail.winner != '' && match.detail.state == 'P' )) {
                    return true
                }
            }
        }
    }
</script>
